module.exports = __webpack_public_path__ + "assets/adc049c8228fab021e80fd5790fd9907.svg";